<template>
  <div class="threeDBigbox" v-show="innerVisibleNew">
    <div class="threeDbox">
      <p class="threeDTitle">3D预览</p>
      <span class="threeClose" @click="closeDlog(false)"> X </span>
      <div id="div_canvas2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "threeD",
  props: {
    innerVisible: {
      type: Boolean,
      default: false,
    },
    fileListNew: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      //   3D预览
      loader: "",
      threeImgs: "",
      innerVisibleNew: false,
    };
  },
  watch: {
    innerVisible(newValue, oldValue) {
      this.innerVisibleNew = newValue;
    },
  },
  mounted() {},
  computed: {},
  methods: {
    closeDlog(isShow) {
      var e = document.getElementById("div_canvas2");
      var child = e.lastElementChild;
      while (child) {
        e.removeChild(child);
        child = e.lastElementChild;
      }
      this.$emit("closeDlog", isShow);
      // console.log("", this.innerVisible);
    },
    threeAnimal(info) {
      // console.log('info',info );
      this.threeImgs = info.url.toLowerCase()
      var div_canvas2 = document.getElementById("div_canvas2");
      var w = 572;
      var h = 400;

      var renderer;

      function initRender() {
        renderer = new THREE.WebGLRenderer({
          antialias: true,
        });
        renderer.setSize(w, h);
        //告诉渲染器需要阴影效果
        renderer.setClearColor(0xffffff);
        div_canvas2.appendChild(renderer.domElement);
      }

      var camera;

      function initCamera() {
        camera = new THREE.PerspectiveCamera(45, w / h, 0.1, 1000);
        camera.position.set(0, 40, 50);
        camera.lookAt(new THREE.Vector3(0, 0, 0));
      }

      var scene;

      function initScene() {
        scene = new THREE.Scene();
      }

      //初始化dat.GUI简化试验流程
      var gui;

      function initGui() {
        //声明一个保存需求修改的相关数据的对象
        gui = {};
        var datGui = new dat.GUI();
        //将设置属性添加到gui当中，gui.add(对象，属性，最小值，最大值）
      }

      var light;

      function initLight() {
        scene.add(new THREE.AmbientLight(0x444444));

        light = new THREE.PointLight(0xffffff);
        light.position.set(0, 50, 50);

        //告诉平行光需要开启阴影投射
        light.castShadow = true;

        scene.add(light);
      }
      let that = this;
      function initModel() {
        //文件路径
        //获取最后一个.的位置
        var index = that.threeImgs.lastIndexOf(".");
        //获取后缀
        var ext = that.threeImgs.substr(index + 1);
        //辅助工具
        // var helper = new THREE.AxesHelper(50);
        // scene.add(helper);
        // 上传文件
        if (ext == "stl") {
          that.loader = new THREE.STLLoader();
        } else if (ext == "obj") {
          that.loader = new THREE.OBJLoader();
        }
        that.loader.load(that.threeImgs, function (geometry) {
           if (ext == "obj") {
            console.log(" geometry.faces", geometry.faces);

            // //创建纹理
            var mat = new THREE.MeshLambertMaterial({
              color: 0x00ffff,
            });
            var mesh = new THREE.Mesh(geometry, mat);
            console.log(
              "new THREE.Box3()",
              new THREE.Box3().setFromObject(mesh).size()
            );
            var boundingBox = new THREE.Box3().setFromObject(mesh).size();

            // 查看加载器生成的材质对象：MeshPhongMaterial
            console.log(geometry.children[0]);
            scene.add(geometry);
            // 加载后的一些编辑操作
            geometry.children[0].scale.set(5, 5, 5); //网格模型缩放
            geometry.children[0].geometry.center(); //网格模型的几何体居中
            geometry.children[0].material.color.set(0x00ffff); //设置材质颜色

            if ((boundingBox.x / 10).toFixed(2) > 50) {
              mesh.scale.set(0.03, 0.03, 0.03); //缩放
            } else if ((boundingBox.x / 10).toFixed(2) < 10) {
              mesh.scale.set(0.5, 0.5, 0.5); //缩放
            }
          } else if (ext == "stl") {
            // console.log('obgeometryj',geometry instanceof THREE.Group);
            if (geometry instanceof THREE.BufferGeometry) {
              geometry = new THREE.Geometry().fromBufferGeometry(geometry);
            }

            //尺寸
            geometry.computeBoundingBox();

            // 计算长宽高
            var boundingBox = geometry.boundingBox;
            // 长宽高
            console.log(
              "x_y_z:",
              ((boundingBox.max.x / 10) * 2).toFixed(2),
              ((boundingBox.max.y / 10) * 2).toFixed(2),
              ((boundingBox.max.z / 10) * 2).toFixed(2)
            ); //实际长宽高，取2x,2y,2z。

            //创建纹理
            var mat = new THREE.MeshLambertMaterial({
              // color: 0x00ffff,
              color: 0x00ffff,
            });
            var mesh = new THREE.Mesh(geometry, mat);
            //console.log(mesh);

            mesh.rotation.x = -0.5 * Math.PI; //将模型摆正
            // mesh.scale.set(0.5, 0.5, 0.5); //缩放
            if ((boundingBox.max.x / 10) * 2 > 50) {
              mesh.scale.set(0.03, 0.03, 0.03); //缩放
            } else if ((boundingBox.max.x / 10) * 2 < 10) {
              mesh.scale.set(0.5, 0.5, 0.5); //缩放
            }
            geometry.center(); //居中显示
            scene.add(mesh);
          }
        });
      }

      //初始化性能插件
      var stats;

      function initStats() {
        stats = new Stats();
        div_canvas2.appendChild(stats.dom);
      }

      //用户交互插件 鼠标左键按住旋转，右键按住平移，滚轮缩放
      var controls;

      function initControls() {
        controls = new THREE.OrbitControls(camera, renderer.domElement);

        // 如果使用animate方法时，将此函数删除
        //controls.addEventListener( 'change', render );
        // 使动画循环使用时阻尼或自转 意思是否有惯性
        controls.enableDamping = true;
        //动态阻尼系数 就是鼠标拖拽旋转灵敏度
        //controls.dampingFactor = 0.25;
        //是否可以缩放
        controls.enableZoom = true;
        //是否自动旋转
        controls.autoRotate = true;
        controls.autoRotateSpeed = 0.5;
        //设置相机距离原点的最远距离
        controls.minDistance = 1;
        //设置相机距离原点的最远距离
        controls.maxDistance = 200;
        //是否开启右键拖拽
        controls.enablePan = true;
      }

      function render() {
        renderer.render(scene, camera);
      }

      //窗口变动触发的函数
      function onWindowResize() {
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
        render();
        renderer.setSize(w, h);
      }

      function animate() {
        //更新控制器
        render();

        //更新性能插件
        stats.update();

        controls.update();

        requestAnimationFrame(animate);
      }

      function draw() {
        initGui();
        initRender();
        initScene();
        initCamera();
        initLight();
        initModel();
        initControls();
        initStats();

        animate();
        window.onresize = onWindowResize;
      }
      draw();
    },
  },
};
</script>

<style lang="less" scoped>
.threeDBigbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #00000038;
}
.threeDbox {
  // width: 100%;
  height: 30px;
  background: #000;
  color: #fff;
  font-size: 18px;
  text-align: center;
  position: relative;
  z-index: 999;
  // position: relative;
  // top: -321px;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);

  .threeDTitle {
    margin: 0;
    height: 30px;
  }
  .threeClose {
    position: absolute;
    top: 0;
    right: 21px;
    cursor: pointer;
  }
  #div_canvas2 {
    background: #000;
  }
}
/deep/.dg.main .close-button {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/threeD/index.vue